// src/data/bundlesData.js - Contains all bundle product data
import { getPriceComparisonUrl } from '../utils/productUrlMapping';

export const bundlesData = [
  {
    id: "Ultra2 106sv + LVS34 Bundle",
    name: "Garmin Ultra2 106sv + LVS34 Bundle",
    type: "bundle",
    msrp: 3899.98,
    csvLookupId: "Ultra2 106sv + LVS34 Bundle",
    priceComparisonUrl: getPriceComparisonUrl("Ultra2 106sv + LVS34 Bundle"),
    image: "/images/bundles/ultra2-106sv-lvs34-bundle.jpg",
    description: "Complete fish finder bundle with Ultra2 106sv screen and LiveScope Plus LVS34 transducer",
    includes: [
      "Garmin EchoMap Ultra2 106sv GN+",
      "LiveScope Plus LVS34"
    ],
    features: [
      "10-inch touchscreen display",
      "LiveScope Plus forward-facing sonar",
      "Preloaded BlueChart g3 maps",
      "Built-in Garmin Navionics+ mapping",
      "Wi-Fi connectivity"
    ],
    productLink: "https://at.fish/Scheels-106sv-LVS34"
  },
  {
    id: "Ultra2 126sv + LVS34 Bundle",
    name: "Garmin Ultra2 126sv + LVS34 Bundle",
    type: "bundle",
    msrp: 4699.98,
    csvLookupId: "Ultra2 126sv + LVS34 Bundle",
    priceComparisonUrl: getPriceComparisonUrl("Ultra2 126sv + LVS34 Bundle"),
    image: "/images/screens/garmin-echomap-ultra2-126sv.jpg",
    description: "Complete fish finder bundle with Ultra2 126sv screen and LiveScope Plus LVS34 transducer",
    includes: [
      "Garmin EchoMap Ultra2 126sv GN+",
      "LiveScope Plus LVS34"
    ],
    features: [
      "12-inch touchscreen display",
      "LiveScope Plus forward-facing sonar",
      "Preloaded BlueChart g3 maps",
      "Built-in Garmin Navionics+ mapping",
      "Wi-Fi connectivity"
    ],
    productLink: "https://at.fish/Scheels-126sv-LVS34"
  }
]; 